//== which steps have had a failed Continue attempt and should now display
//== validation errors. armed status persists across navigation - once a
//== step is armed, its errors stay visible (or hide as the user fixes them)
//== until Start Over clears the set.

const armedSteps = new Set()
const listeners = new Set()

export function isArmed(step) {
  return armedSteps.has(step)
}

export function arm(step) {
  if (armedSteps.has(step)) return
  armedSteps.add(step)
  notify()
}

export function clearArmed() {
  if (!armedSteps.size) return
  armedSteps.clear()
  notify()
}

export function subscribeArmed(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

function notify() {
  for (const fn of listeners) fn()
}
